import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicNavbar from '../components/layout/PublicNavbar';

const LandingPage = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load campaigns from localStorage on component mount
  useEffect(() => {
    const loadCampaigns = () => {
      setLoading(true);
      const savedCampaigns = localStorage.getItem('campaigns');
      if (savedCampaigns) {
        setCampaigns(JSON.parse(savedCampaigns));
      } else {
        // If no campaigns in localStorage, we'll show a message
        setCampaigns([]);
      }
      setLoading(false);
    };
    
    loadCampaigns();
  }, []);
  return (
    <div className="landing-page">
      <PublicNavbar />
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
        <div className="container mx-auto px-6 pt-28 pb-20 md:pt-36 md:pb-32">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
                DynPro Alumni Network
              </h1>
              <p className="text-xl md:text-2xl mb-8 opacity-90">
                Reconnect with former colleagues, explore new opportunities, and stay connected with the DynPro community.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/register" className="bg-white text-blue-700 font-bold py-3 px-6 rounded-lg shadow-lg hover:bg-blue-50 transition duration-300 text-center">
                  Join the Community
                </Link>
                <Link to="/login" className="bg-transparent border-2 border-white text-white font-bold py-3 px-6 rounded-lg hover:bg-white hover:bg-opacity-10 transition duration-300 text-center">
                  Sign In
                </Link>
              </div>
            </div>
            <div className="md:w-1/2 md:pl-10">
              <img src="/images/network-illustration.svg" alt="Alumni Network" className="w-full" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-4 text-gray-800">Why Join Our Alumni Network?</h2>
          <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12">Discover the benefits of being part of the DynPro community</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition duration-300">
              <div className="bg-blue-100 text-blue-600 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Reconnect with Colleagues</h3>
              <p className="text-gray-600">
                Find and reconnect with former colleagues, mentors, and team members who shared your DynPro journey.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition duration-300">
              <div className="bg-blue-100 text-blue-600 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Exclusive Opportunities</h3>
              <p className="text-gray-600">
                Access exclusive job opportunities, consulting projects, and partnership possibilities shared only with our alumni network.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition duration-300">
              <div className="bg-blue-100 text-blue-600 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Stay Updated</h3>
              <p className="text-gray-600">
                Receive regular updates about DynPro's growth, industry insights, and special events for alumni.
              </p>
            </div>
          </div>
        </div>
      </section>



      {/* Active Campaigns Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-4 text-gray-800">Current Alumni Campaigns</h2>
          <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12">Join our targeted outreach initiatives to reconnect with the DynPro community</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {loading ? (
              <div className="col-span-3 flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
              </div>
            ) : campaigns.length > 0 ? (
              campaigns.map(campaign => {
                // Format dates
                const startDate = new Date(campaign.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
                const endDate = new Date(campaign.endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
                
                // Calculate completion percentage
                const completionPercentage = campaign.targetCount > 0 ? Math.round((campaign.completedCount / campaign.targetCount) * 100) : 0;
                
                // Determine status color
                const statusColor = {
                  'active': 'bg-green-100 text-green-800',
                  'planned': 'bg-yellow-100 text-yellow-800',
                  'completed': 'bg-blue-100 text-blue-800',
                  'cancelled': 'bg-red-100 text-red-800',
                  'paused': 'bg-gray-100 text-gray-800'
                }[campaign.status.toLowerCase()] || 'bg-gray-100 text-gray-800';
                
                return (
                  <div key={campaign.id} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition duration-300 border border-gray-200">
                    <div className="flex justify-between items-start mb-3">
                      <h3 className="text-xl font-semibold text-gray-800">{campaign.name}</h3>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusColor}`}>
                        {campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1)}
                      </span>
                    </div>
                    <p className="text-gray-600 mb-4 line-clamp-2 h-12">{campaign.description}</p>
                    <div className="flex justify-between text-sm text-gray-500 mb-4">
                      <div>
                        <span className="block">Start: {startDate}</span>
                        <span className="block">End: {endDate}</span>
                      </div>
                      <div className="text-right">
                        <span className="block">Target: {campaign.targetCount}</span>
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {campaign.tags && campaign.tags.map((tag, index) => (
                        <span key={index} className="bg-gray-100 text-gray-600 px-2 py-1 rounded-md text-xs">{tag}</span>
                      ))}
                    </div>
                    <Link to={`/app/campaigns/${campaign.id}`} className="text-blue-600 font-medium hover:text-blue-800">
                      View Details →
                    </Link>
                  </div>
                );
              })
            ) : (
              <div className="col-span-3 bg-white p-8 rounded-xl shadow-md text-center">
                <svg className="w-16 h-16 mx-auto text-blue-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">No Active Campaigns</h3>
                <p className="text-gray-600 mb-6">There are currently no campaigns available. Visit the campaigns page to create one.</p>
                <Link to="/app/campaigns" className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200">
                  Go to Campaigns
                </Link>
              </div>
            )}
          </div>
          <div className="text-center mt-10">
            <Link to="/app/campaigns" className="inline-block bg-blue-600 text-white font-bold py-3 px-8 rounded-lg hover:bg-blue-700 transition duration-300">
              View All Campaigns
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-16 bg-blue-700 text-white">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Stay Connected</h2>
            <p className="text-xl mb-8 opacity-90">
              Subscribe to our alumni newsletter to receive updates on events, opportunities, and community news.
            </p>
            <form className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
              <input
                type="email"
                placeholder="Your email address"
                className="flex-1 px-4 py-3 rounded-lg text-gray-900 focus:outline-none"
              />
              <button
                type="submit"
                className="bg-blue-900 hover:bg-blue-800 px-6 py-3 rounded-lg font-bold transition duration-300"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-blue-800 to-indigo-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-bold mb-4">DynPro Alumni</h3>
              <p className="text-gray-400">
                Connecting former employees and building a community of professionals who shared the DynPro experience.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/about" className="text-gray-400 hover:text-white">About Us</Link></li>
                <li><Link to="/events" className="text-gray-400 hover:text-white">Events</Link></li>
                <li><Link to="/opportunities" className="text-gray-400 hover:text-white">Opportunities</Link></li>
                <li><Link to="/resources" className="text-gray-400 hover:text-white">Resources</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">Connect</h4>
              <ul className="space-y-2">
                <li><Link to="/contact" className="text-gray-400 hover:text-white">Contact Us</Link></li>
                <li><a href="https://linkedin.com/company/dynpro" className="text-gray-400 hover:text-white">LinkedIn</a></li>
                <li><a href="https://twitter.com/dynpro" className="text-gray-400 hover:text-white">Twitter</a></li>
                <li><a href="https://facebook.com/dynpro" className="text-gray-400 hover:text-white">Facebook</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">Legal</h4>
              <ul className="space-y-2">
                <li><Link to="/privacy" className="text-gray-400 hover:text-white">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-gray-400 hover:text-white">Terms of Service</Link></li>
                <li><Link to="/cookies" className="text-gray-400 hover:text-white">Cookie Policy</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
            <p>© {new Date().getFullYear()} DynPro Alumni Network. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
